import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

interface DeleteLandingItemModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    title: string;
    itemName: string;
    loading: boolean;
}

export const DeleteLandingItemModal: React.FC<DeleteLandingItemModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    itemName,
    loading,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
            <div className="relative w-full max-w-md bg-white dark:bg-[#120a21] rounded-2xl shadow-2xl border border-gray-100 dark:border-purple-900/40 p-6 overflow-hidden">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-full hover:bg-gray-100 dark:hover:bg-purple-950/40 transition-colors"
                >
                    <X size={18} />
                </button>

                <div className="flex items-center gap-3 text-red-500 mb-4">
                    <div className="p-3 bg-red-100 dark:bg-red-950/40 rounded-xl">
                        <AlertTriangle size={24} />
                    </div>
                    <div>
                        <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                            {title}
                        </h3>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                            Esta acción no se puede deshacer
                        </p>
                    </div>
                </div>

                <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
                    ¿Estás seguro de que deseas eliminar{' '}
                    <strong className="text-gray-900 dark:text-white font-semibold">
                        "{itemName}"
                    </strong>?
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={loading}
                        className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-purple-950/40 rounded-xl transition-colors disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={loading}
                        className="px-5 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-xl shadow-lg shadow-red-600/30 transition-all disabled:opacity-50 flex items-center gap-2"
                    >
                        {loading ? (
                            <>
                                <span className="inline-block w-4 h-4 border-2 border-white/20 border-t-white rounded-full animate-spin" />
                                Eliminando...
                            </>
                        ) : (
                            'Eliminar elemento'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};
